import { ServiceLayout } from "@/components/service/ServiceLayout";
import { ServiceFAQ } from "@/components/service/ServiceFAQ";
import { HeroSection } from "@/components/ppc-marketing/HeroSection";
import { WhyChooseUs } from "@/components/ppc-marketing/WhyChooseUs";
import { ServicesGrid } from "@/components/ppc-marketing/ServicesGrid";
import { ServiceCTA } from "@/components/ui/ServiceCTA";
import { serviceFAQs } from "@/data/service-faqs";

const PPCMarketing = () => {
  return (
    <ServiceLayout serviceName="PPC Marketing">
      <HeroSection />
      <WhyChooseUs />
      <ServicesGrid />
      <ServiceFAQ faqs={serviceFAQs["ppc-marketing"]} serviceName="PPC Marketing" />
      <ServiceCTA serviceName="PPC Marketing" />
    </ServiceLayout>
  );
};

export default PPCMarketing;